/* eur-pdp.js - V5 product page (Mix 3, Mix 1 parts kept) behaviour. Loaded by sections/eur-pdp-main.liquid, only on product.v5.
   Server-rendered markup; this file only adds behaviour and live data:
   gallery (photos fitted to the stage), quantity, variant reload, Add-to-basket proxies (jump bar, phone bar, comparison) that click the real
   <buy-button> button, sticky jump bar (offset under the theme's sticky header), delivery estimate (Irish working
   days, Europe/Dublin), humm plans (humm widget API), Feefo summaries + reviews widget, comparison "differences only",
   specs "show all", Otto, Find-in-store proxy, manufacturer content reveal, disclosure links, sponsored tracking. */
(function () {
  'use strict';
  if (window.__eurPdp) return;
  window.__eurPdp = true;

  var d = document;
  function q(s, c) { return (c || d).querySelector(s); }
  function qa(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function money(n) {
    var p = (Math.round(n * 100) / 100).toFixed(2).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '€' + (p[1] === '00' ? p[0] : p.join('.'));
  }
  function money2(n) {
    var p = (Math.round(n * 100) / 100).toFixed(2).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '€' + p.join('.');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cacheGet(k) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function cacheSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function getJSON(url, key) {
    var c = key ? cacheGet(key) : null;
    if (c) return Promise.resolve(c);
    return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { if (key) cacheSet(key, j); return j; });
  }

  var main = q('[data-ep-main]');

  /* ---------- gallery ---------- */
  function initGallery() {
    var gal = q('[data-ep-gal]');
    if (!gal) return;
    var track = q('[data-ep-track]', gal), slides, n, thumbs, dots;
    var num = q('[data-ep-i]', gal), tot = q('[data-ep-n]', gal), zoom = q('[data-ep-zoom]', gal);
    var prev = q('[data-ep-step="-1"]', gal), next = q('[data-ep-step="1"]', gal);
    var cur = 0, raf = 0;
    /* keep = a slide whose video its thumbnail just started: not paused while the gallery scrolls past the other slides to it */
    var keep = -1;
    function collect() {
      slides = qa('[data-ep-slide]', gal); n = slides.length;
      thumbs = qa('[data-ep-go]', gal); dots = qa('.ep-dots span', gal);
    }
    collect();
    function go(i, smooth) {
      i = Math.max(0, Math.min(n - 1, i));
      if (smooth !== false) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); return; }
      /* a jump: the track's CSS scroll-behavior is smooth, so it is switched off for this one scroll */
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = i * track.clientWidth;
      track.style.scrollBehavior = '';
    }
    function mark(i) {
      if (i === cur && num && num.textContent === String(i + 1)) return;
      cur = i;
      if (num) num.textContent = String(i + 1);
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      dots.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === n - 1;
      var th = thumbs[i];
      if (th && th.parentNode && th.parentNode.scrollHeight > th.parentNode.clientHeight + 4) {
        var box = th.parentNode, top = th.offsetTop - box.offsetTop;
        if (top < box.scrollTop || top + th.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTo({ top: top - 8, behavior: 'smooth' });
      }
      slides.forEach(function (s, k) { var v = q('video', s); if (v && k !== i && k !== keep && !v.paused) v.pause(); });
      if (i === keep) keep = -1;
      /* on the Flix video: no count, dots or zoom over the player's controls */
      gal.classList.toggle('is-vid', !!(slides[i] && slides[i].classList.contains('ep-slide--fvid')));
    }
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    }, { passive: true });
    ['pointerdown', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { keep = -1; }, { passive: true }); });
    gal.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-ep-go]') : null;
      if (!t || !gal.contains(t)) return;
      var to = +t.getAttribute('data-ep-go');
      /* the video thumbnail jumps to the video and starts it, inside the click, so the browser (Safari too) lets it play
         with sound. A jump, not a glide: a video started while it is still being scrolled into view gets paused */
      var v = t.classList.contains('ep-thumb--video') && q('.ep-slide--fvid video', gal);
      if (!v || !v.paused) { go(to); return; }
      if (to !== cur) keep = to;
      go(to, false);
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    });
    qa('[data-ep-step]', gal).forEach(function (b) { b.addEventListener('click', function () { go(cur + +b.getAttribute('data-ep-step')); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    window.addEventListener('resize', function () { go(cur, false); });
    /* ---------- full-screen photo viewer (12 Oct 2026) ----------
       Opens from the expand button, or a click / tap on a photo, at the photo on screen; full screen on every size.
       All the product photos (the video stays in the gallery), swipe or arrows / arrow keys / thumbnails between them.
       Zoom: a click or a double-tap toggles 2.5x at that spot; on a computer the mouse then pans the photo; on touch a
       pinch zooms 1-4x and one finger pans a zoomed photo. Closing (button, Escape) leaves the gallery on the last photo. */
    var lb = q('[data-ep-lb]');
    if (lb && typeof lb.showModal === 'function') initViewer(); else if (zoom) zoom.hidden = true;

    function initViewer() {
      var html = d.documentElement, closeBtn = q('[data-ep-lb-close]', lb);
      var vw, vTrack, vSlides = [], vThumbs = [], vNum, vPrev, vNext, photos = [], built = '', vi = 0, vraf = 0;
      var Z = { s: 1, x: 0, y: 0 }, ZMAX = 4, ZTAP = 2.5;
      var touchUI = window.matchMedia && window.matchMedia('(hover: none)').matches;
      function big(im) {
        var u = im.currentSrc || im.src || '';
        if (!u || /^data:/.test(u)) return '';
        return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=2048') : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=2048';
      }
      function readPhotos() {
        photos = [];
        slides.forEach(function (s, k) {
          if (s.classList.contains('ep-slide--fvid')) return;
          var im = q('img', s); if (!im) return;
          var src = big(im); if (src) photos.push({ k: k, src: src, thumb: im.currentSrc || im.src, alt: im.alt || '' });
        });
      }
      function build() {
        var key = photos.map(function (p) { return p.src; }).join('|');
        if (key === built) return;
        built = key;
        var name = q('[data-ep-main] h1'), nm = name ? name.textContent.replace(/\s+/g, ' ').trim() : '';
        lb.innerHTML = '';
        vw = d.createElement('div'); vw.className = 'ep-vw';
        vw.innerHTML =
          '<div class="ep-vw__top"><span class="ep-vw__name"></span><span class="ep-vw__hint">' + (touchUI ? 'Pinch or double-tap to zoom' : 'Click to zoom') + '</span><span class="ep-vw__n" aria-live="polite"><b data-vw-i>1</b> / ' + photos.length + '</span></div>' +
          '<div class="ep-vw__stage"><div class="ep-vw__track" data-vw-track tabindex="-1"></div>' +
          '<button type="button" class="ep-vw__arw ep-vw__arw--prev" data-vw-step="-1" aria-label="Previous photo"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button>' +
          '<button type="button" class="ep-vw__arw ep-vw__arw--next" data-vw-step="1" aria-label="Next photo"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button></div>' +
          '<div class="ep-vw__thumbs" role="group" aria-label="Photos"></div>';
        q('.ep-vw__name', vw).textContent = nm;
        q('.ep-vw__top', vw).appendChild(closeBtn);
        vTrack = q('[data-vw-track]', vw); vNum = q('[data-vw-i]', vw);
        vPrev = q('[data-vw-step="-1"]', vw); vNext = q('[data-vw-step="1"]', vw);
        var tbox = q('.ep-vw__thumbs', vw);
        photos.forEach(function (p, i) {
          var f = d.createElement('figure'); f.className = 'ep-vw__s'; f.setAttribute('aria-label', (i + 1) + ' of ' + photos.length);
          var im = d.createElement('img'); im.alt = p.alt; im.decoding = 'async'; im.draggable = false; im.setAttribute('data-src', p.src);
          f.appendChild(im); vTrack.appendChild(f);
          var t = d.createElement('button'); t.type = 'button'; t.className = 'ep-vw__t'; t.setAttribute('aria-label', 'Photo ' + (i + 1));
          t.innerHTML = '<img alt="">'; t.firstChild.src = p.thumb;
          t.addEventListener('click', function () { vGo(i); });
          tbox.appendChild(t);
        });
        if (photos.length < 2) { tbox.hidden = true; vPrev.hidden = true; vNext.hidden = true; }
        lb.appendChild(vw);
        vSlides = qa('.ep-vw__s', vw); vThumbs = qa('.ep-vw__t', vw);
        qa('[data-vw-step]', vw).forEach(function (b) { b.addEventListener('click', function () { vGo(vi + +b.getAttribute('data-vw-step')); }); });
        vTrack.addEventListener('scroll', function () {
          if (vraf) return;
          vraf = requestAnimationFrame(function () { vraf = 0; vMark(Math.round(vTrack.scrollLeft / Math.max(1, vTrack.clientWidth))); });
        }, { passive: true });
        bindZoom();
      }
      function load(i) { [i - 1, i, i + 1].forEach(function (k) { var im = vSlides[k] && q('img', vSlides[k]); if (im && !im.getAttribute('src')) im.src = im.getAttribute('data-src'); }); }
      function vGo(i, jump) {
        i = Math.max(0, Math.min(photos.length - 1, i));
        if (i !== vi) reset();
        load(i);
        vTrack.scrollTo({ left: i * vTrack.clientWidth, behavior: jump ? 'auto' : 'smooth' });
        vMark(i);
      }
      function vMark(i) {
        if (i !== vi) reset();
        vi = i; load(i);
        vNum.textContent = String(i + 1);
        vThumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
        var t = vThumbs[i]; if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollLeft = t.offsetLeft - t.parentNode.clientWidth / 2 + t.offsetWidth / 2;
        vPrev.disabled = i === 0; vNext.disabled = i === photos.length - 1;
      }

      /* zoom: the photo box is the slide's content box; a zoomed photo may pan until its drawn edge meets the box edge */
      function curImg() { return vSlides[vi] && q('img', vSlides[vi]); }
      function limits(im) {
        var bw = im.clientWidth, bh = im.clientHeight, ar = (im.naturalWidth || 1) / (im.naturalHeight || 1);
        var dw = Math.min(bw, bh * ar), dh = dw / ar;
        return { x: Math.max(0, (dw * Z.s - bw) / 2), y: Math.max(0, (dh * Z.s - bh) / 2), bw: bw, bh: bh };
      }
      function apply() {
        var im = curImg(); if (!im) return;
        var L = limits(im);
        Z.x = Math.max(-L.x, Math.min(L.x, Z.x)); Z.y = Math.max(-L.y, Math.min(L.y, Z.y));
        im.style.transform = Z.s === 1 ? '' : 'translate(' + Z.x.toFixed(1) + 'px,' + Z.y.toFixed(1) + 'px) scale(' + Z.s.toFixed(3) + ')';
        vTrack.classList.toggle('is-zoomed', Z.s > 1);
      }
      function reset() { var im = curImg(); Z = { s: 1, x: 0, y: 0 }; if (im) im.style.transform = ''; if (vTrack) vTrack.classList.remove('is-zoomed'); }
      function zoomAt(cx, cy, s) {
        var im = curImg(); if (!im) return;
        var box = im.parentNode.getBoundingClientRect();
        var ox = (box.left + box.right) / 2, oy = (box.top + box.bottom) / 2;
        var px = cx - ox, py = cy - oy;
        /* keep the point under the cursor / finger still: p' = p * s + t  =>  t = p - (p - t0) * s / s0 */
        Z.x = px - (px - Z.x) * s / Z.s; Z.y = py - (py - Z.y) * s / Z.s; Z.s = s;
        if (s === 1) { Z.x = 0; Z.y = 0; }
        apply();
      }
      function bindZoom() {
        var mouse = false;
        /* computer: click toggles, the mouse pans the zoomed photo edge to edge */
        vTrack.addEventListener('click', function (e) {
          if (!mouse) return;
          var im = curImg(); if (!im || !im.parentNode.contains(e.target)) return;
          if (Z.s > 1) { zoomAt(e.clientX, e.clientY, 1); return; }
          zoomAt(e.clientX, e.clientY, ZTAP); pan(e);
        });
        function pan(e) {
          var im = curImg(); if (!im || Z.s === 1) return;
          var box = im.parentNode.getBoundingClientRect(), L = limits(im);
          var fx = ((e.clientX - box.left) / box.width) * 2 - 1, fy = ((e.clientY - box.top) / box.height) * 2 - 1;
          Z.x = -fx * L.x; Z.y = -fy * L.y;
          vTrack.classList.add('is-drag'); apply();
        }
        vTrack.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') pan(e); });
        vTrack.addEventListener('pointerdown', function (e) { mouse = e.pointerType === 'mouse'; vTrack.classList.toggle('is-drag', false); });
        vTrack.addEventListener('wheel', function (e) { if (Z.s > 1) e.preventDefault(); }, { passive: false });
        /* touch: pinch, pan while zoomed, double-tap */
        var g = null, lastTap = 0, lastX = 0, lastY = 0;
        function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
        function mid(t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; }
        vTrack.addEventListener('touchstart', function (e) {
          var im = curImg(); if (!im) return;
          var box = im.parentNode.getBoundingClientRect(), o = { x: (box.left + box.right) / 2, y: (box.top + box.bottom) / 2 };
          if (e.touches.length === 2) {
            e.preventDefault();
            var m = mid(e.touches);
            g = { mode: 'pinch', d0: dist(e.touches), s0: Z.s, x0: Z.x, y0: Z.y, m0: { x: m.x - o.x, y: m.y - o.y }, o: o };
            vTrack.classList.add('is-drag', 'is-zoomed');
          } else if (e.touches.length === 1 && Z.s > 1) {
            g = { mode: 'pan', sx: e.touches[0].clientX, sy: e.touches[0].clientY, x0: Z.x, y0: Z.y };
            vTrack.classList.add('is-drag');
          } else g = null;
        }, { passive: false });
        vTrack.addEventListener('touchmove', function (e) {
          if (!g) return;
          e.preventDefault();
          if (g.mode === 'pinch' && e.touches.length === 2) {
            var s = Math.max(1, Math.min(ZMAX, g.s0 * dist(e.touches) / g.d0));
            var m = mid(e.touches), mx = m.x - g.o.x, my = m.y - g.o.y;
            Z.x = mx - (g.m0.x - g.x0) * s / g.s0; Z.y = my - (g.m0.y - g.y0) * s / g.s0; Z.s = s;
            apply();
          } else if (g.mode === 'pan' && e.touches.length === 1) {
            var dx = e.touches[0].clientX - g.sx, dy = e.touches[0].clientY - g.sy;
            if (Math.abs(dx) + Math.abs(dy) > 8) g.moved = true;
            Z.x = g.x0 + dx; Z.y = g.y0 + dy;
            apply();
          }
        }, { passive: false });
        vTrack.addEventListener('touchend', function (e) {
          vTrack.classList.remove('is-drag');
          if (g && g.mode === 'pinch' && e.touches.length === 1) { g = { mode: 'pan', sx: e.touches[0].clientX, sy: e.touches[0].clientY, x0: Z.x, y0: Z.y }; return; }
          if (e.touches.length) return;
          /* a finger that stayed put on a zoomed photo is a tap, not a pan */
          var wasGesture = !!g && !(g.mode === 'pan' && !g.moved); g = null;
          if (Z.s < 1.05) { reset(); }
          if (wasGesture || e.changedTouches.length !== 1) return;
          var t = e.changedTouches[0], now = Date.now();
          if (now - lastTap < 320 && Math.abs(t.clientX - lastX) < 30 && Math.abs(t.clientY - lastY) < 30) {
            e.preventDefault(); lastTap = 0;
            zoomAt(t.clientX, t.clientY, Z.s > 1 ? 1 : ZTAP);
          } else { lastTap = now; lastX = t.clientX; lastY = t.clientY; }
        });
        /* Safari's own page zoom stays out of the viewer */
        ['gesturestart', 'gesturechange'].forEach(function (ev) { lb.addEventListener(ev, function (e) { e.preventDefault(); }); });
      }

      function open() {
        readPhotos();
        if (!photos.length) return;
        build();
        var at = 0;
        photos.forEach(function (p, i) { if (p.k <= cur) at = i; });
        reset();
        html.classList.add('ep-vw-open');
        lb.showModal();
        shown = true;
        vi = -1;
        vGo(at, true);
        try { vTrack.focus({ preventScroll: true }); } catch (err) {}
      }
      if (zoom) zoom.addEventListener('click', open);
      /* a click / tap on a photo (not on the video, not a swipe) */
      track.addEventListener('click', function (e) {
        var im = e.target.closest && e.target.closest('.ep-slide img');
        if (!im || im.closest('.ep-slide--fvid')) return;
        open();
      });
      var shown = false;
      function finish() {
        if (!shown) return;
        shown = false;
        html.classList.remove('ep-vw-open');
        reset();
        var p = photos[vi]; if (p) go(p.k, false);
        if (zoom) try { zoom.focus({ preventScroll: true }); } catch (err) {}
      }
      closeBtn.addEventListener('click', function () { lb.close(); finish(); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); vGo(vi + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); vGo(vi - 1); }
      });
      lb.addEventListener('close', finish);
      window.addEventListener('resize', function () { if (lb.open && vTrack) { reset(); vTrack.scrollLeft = vi * vTrack.clientWidth; } });
    }

    /* Flixmedia product video. Flix's "View video" button (with its Features / Specifications buttons) is placed over
       the old theme's gallery (Flix setting: .product-gallery__size-limiter .aspect-ratio); without it the buttons land
       in the page's top-left corner and the video opens in a pop-up over the buy box. Those are hidden (eur-pdp.css)
       and the same video (Flix's own data: FlixServices.modular_hotspot_data.product_video) becomes the last item of
       this gallery, in the browser's own player. MP4 only (an HLS stream does not play in every browser). */
    function absUrl(u, re) {
      u = String(u || '').trim();
      if (/^\/\//.test(u)) u = 'https:' + u;
      u = u.replace(/^http:\/\//i, 'https://');
      return /^https:\/\/[^\s"'<>]+$/i.test(u) && (!re || re.test(u)) ? u : '';
    }
    function flixVideo() {
      var fs = window.FlixServices, hd = fs && fs.modular_hotspot_data, pv = hd && hd.product_video;
      if (!pv || !pv.html || typeof DOMParser === 'undefined') return null;
      try {
        var inp = new DOMParser().parseFromString(String(pv.html), 'text/html').querySelector('input.flix-jw');
        var list = inp && JSON.parse(inp.value).playlist, it = list && list[0];
        if (!it) return null;
        var mp4 = /\.mp4(\?|$)/i, src = absUrl(it.file, mp4);
        if (!src && it.sources) it.sources.some(function (x) { src = absUrl(x && x.file, mp4); return !!src; });
        if (!src) return null;
        return { src: src, poster: absUrl(it.image), title: String(it.title || '').split(' | ')[0].trim() };
      } catch (e) { return null; }
    }
    function addVideo(v) {
      if (q('.ep-slide--fvid', gal)) return;
      var i = n, label = v.title ? 'Product video: ' + v.title : 'Product video';
      var fig = d.createElement('figure');
      fig.className = 'ep-slide ep-slide--fvid';
      fig.setAttribute('data-ep-slide', '');
      fig.setAttribute('aria-label', label);
      var vid = d.createElement('video');
      vid.controls = true; vid.preload = 'none'; vid.playsInline = true;
      vid.setAttribute('playsinline', '');
      if (v.poster) vid.poster = v.poster;
      vid.src = v.src;
      fig.appendChild(vid);
      track.appendChild(fig);
      var rail = q('.ep-thumbs', gal);
      if (rail) {
        var b = d.createElement('button');
        b.type = 'button';
        b.className = 'ep-thumb ep-thumb--video';
        b.setAttribute('data-ep-go', String(i));
        b.setAttribute('aria-label', 'Play the ' + label.charAt(0).toLowerCase() + label.slice(1));
        if (v.poster) { var im = d.createElement('img'); im.src = v.poster; im.alt = ''; im.loading = 'lazy'; b.appendChild(im); }
        b.insertAdjacentHTML('beforeend', '<span class="ep-thumb__play" aria-hidden="true"><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.6-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z"/></svg></span>');
        rail.appendChild(b);
      }
      var dw = q('.ep-dots', gal);
      if (dw && dots.length < 11) dw.appendChild(d.createElement('span'));
      collect();
      if (tot) tot.textContent = String(n);
      qa('[data-ep-more]', gal).forEach(function (e) { e.hidden = false; });
      var c = cur; cur = -1; mark(c);
    }
    var tries = 0;
    (function waitFlix() {
      var v = flixVideo();
      if (v) addVideo(v);
      else if (++tries < 60) setTimeout(waitFlix, 500);
    })();
  }

  /* ---------- quantity, variant, add-to-basket proxies ---------- */
  function initBuy() {
    qa('[data-ep-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = q('input[name="quantity"]', b.parentNode);
        if (!inp) return;
        var max = +inp.max || 99, v = (+inp.value || 1) + +b.getAttribute('data-ep-qty');
        inp.value = Math.max(1, Math.min(max, v));
      });
    });
    var sel = q('[data-ep-variant]');
    if (sel) sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', sel.value);
      window.location.assign(u.toString());
    });
    var atc = q('[data-ep-main-atc]');
    d.addEventListener('click', function (e) {
      var p = e.target.closest ? e.target.closest('[data-ep-atc-proxy]') : null;
      if (!p) return;
      e.preventDefault();
      if (atc && !atc.disabled) atc.click();
      else if (main) main.scrollIntoView({ behavior: 'smooth' });
    });
    /* phone bar: shown once the real Add to basket row has scrolled away */
    var bar = q('[data-ep-sbar]'), row = q('.ep-atcrow');
    if (bar && row && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var off = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-on', off);
        d.documentElement.classList.toggle('ep-sbar-on', off);
      }).observe(row);
    }
    /* stockinstore: relabel its button, and let other "Find it in a Euronics store" links open it */
    function fis() {
      var b = q('#checkStoreBtn');
      if (!b) return null;
      var w = d.createTreeWalker(b, NodeFilter.SHOW_TEXT, null, false), t;
      while ((t = w.nextNode())) { if (/find in store|check stock in store/i.test(t.textContent)) t.textContent = ' Find it in a Euronics store'; }
      return b;
    }
    var tries = 0, ti = setInterval(function () { if (fis() || ++tries > 20) clearInterval(ti); }, 500);
    d.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-ep-fis-proxy]') : null;
      if (!a) return;
      var b = fis();
      if (b) { e.preventDefault(); b.click(); }
    });
  }

  /* ---------- jump bar ---------- */
  function initJump() {
    var bar = q('[data-ep-jump]');
    var root = d.documentElement;
    function headerOffset() {
      var max = 0;
      qa('.shopify-section-group-header-group, #shopify-section-header, header.header, .header').forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
        var r = el.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > max && r.height < 260) max = r.bottom;
      });
      return Math.max(0, Math.round(max));
    }
    var last = -1;
    function setTop() { var t = headerOffset(); if (t !== last) { last = t; root.style.setProperty('--ep-top', t + 'px'); } }
    setTop();
    var tabs = bar ? qa('.ep-tab', bar) : [];
    var items = [];
    tabs.forEach(function (a) {
      var id = (a.getAttribute('href') || '').slice(1), el = id ? d.getElementById(id) : null;
      if (!el) { a.parentNode.hidden = true; return; }
      items.push({ a: a, el: el });
    });
    if (bar && !items.length) bar.hidden = true;
    var dl = q('[data-ep-decide-link]');
    if (dl && !d.getElementById('decide')) dl.hidden = true;
    var raf = 0;
    function onScroll() {
      raf = 0;
      setTop();
      if (!items.length) return;
      var line = last + (bar ? bar.offsetHeight : 0) + 24, act = null;
      items.forEach(function (it) { if (it.el.getBoundingClientRect().top <= line) act = it; });
      items.forEach(function (it) { if (it === act) it.a.setAttribute('aria-current', 'true'); else it.a.removeAttribute('aria-current'); });
      if (act && act.a.parentNode.parentNode.scrollWidth > act.a.parentNode.parentNode.clientWidth) {
        var ul = act.a.parentNode.parentNode, l = act.a.offsetLeft - 16;
        if (l < ul.scrollLeft || act.a.offsetLeft + act.a.offsetWidth > ul.scrollLeft + ul.clientWidth) ul.scrollTo({ left: l, behavior: 'smooth' });
      }
    }
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(onScroll); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(onScroll); });
    onScroll();
  }

  /* ---------- delivery estimate (same tiers as the default template; Dublin time; 1pm switch as today). A pre-order
     (data-ep-eta-from="YYYY-MM-DD", snippets/eur-preorder.liquid) counts its working days from that date instead. ---------- */
  function initEta() {
    var els = qa('[data-ep-eta]');
    if (!els.length) return;
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function key(x) { return x.getFullYear() + '-' + pad(x.getMonth() + 1) + '-' + pad(x.getDate()); }
    function firstMon(y, m) { var f = new Date(y, m, 1); return new Date(y, m, 1 + ((8 - f.getDay()) % 7)); }
    function hols(y) {
      var h = [y + '-01-01', y + '-03-17', y + '-12-25', y + '-12-26'];
      var feb1 = new Date(y, 1, 1);
      h.push(key(feb1.getDay() === 5 ? feb1 : firstMon(y, 1))); /* St Brigid's Day: 1 Feb if a Friday, else first Monday */
      var a = y % 19, b = Math.floor(y / 100), c = y % 100, dd = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3), hh = (19 * a + b - dd - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - hh - k) % 7, m = Math.floor((a + 11 * hh + 22 * l) / 451),
        em = Math.floor((hh + l - 7 * m + 114) / 31), ed = (hh + l - 7 * m + 114) % 31 + 1;
      h.push(key(new Date(y, em - 1, ed + 1)));
      h.push(key(firstMon(y, 4)), key(firstMon(y, 5)), key(firstMon(y, 7)));
      var o31 = new Date(y, 9, 31); h.push(key(new Date(y, 9, 31 - ((o31.getDay() + 6) % 7))));
      return h;
    }
    var now;
    try { now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Dublin' })); } catch (e) { now = new Date(); }
    var H = hols(now.getFullYear()).concat(hols(now.getFullYear() + 1));
    var DN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], MN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    els.forEach(function (el) {
      var days = parseInt(el.getAttribute('data-ep-eta'), 10);
      if (!(days > 0)) return;
      var x = new Date(now.getTime());
      if (x.getHours() >= 13) x.setDate(x.getDate() + 1);
      var from = /^(\d{4})-(\d{2})-(\d{2})$/.exec(el.getAttribute('data-ep-eta-from') || '');
      if (from) {
        var fd = new Date(+from[1], +from[2] - 1, +from[3], 12);
        if (fd > x) x = fd;
      }
      var added = 0;
      while (added < days) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6 && H.indexOf(key(x)) === -1) added++; }
      var out = q('[data-ep-eta-date]', el);
      if (out) out.textContent = DN[x.getDay()] + ' ' + x.getDate() + ' ' + MN[x.getMonth()];
      el.hidden = false;
      var fb = el.parentNode ? q('[data-ep-eta-fallback]', el.parentNode) : null;
      if (fb) fb.hidden = true;
    });
  }

  /* ---------- humm (plans from humm's widget API for this exact price) ---------- */
  function initHumm() {
    var row = q('[data-ep-humm]');
    if (!row) return;
    var amt = parseFloat(row.getAttribute('data-amount')), mid = row.getAttribute('data-merchant');
    if (!(amt >= 5) || !mid) return;
    var url = 'https://urkwvzhzpc.execute-api.eu-west-1.amazonaws.com/prod/widget/' + encodeURIComponent(mid) + '/' + amt.toFixed(2) + '/0';
    getJSON(url, 'eurhumm:' + mid + ':' + amt.toFixed(2)).then(function (plans) {
      if (!plans || !plans.length) return;
      var free = null, paid = [];
      plans.forEach(function (p) { if (p.interest) paid.push(p); else if (!free) free = p; });
      function monthly(p) { return (+p.intAmt || 0) + (+p.acctKeepingFee || 0); }
      paid.sort(function (a, b) { return monthly(a) - monthly(b); });
      var line = q('[data-ep-humm-line]', row), sub = q('[data-ep-humm-sub]', row);
      if (free) {
        line.innerHTML = 'or <b>3 interest-free payments of ' + money2(+free.intFreeAmt || amt / 3) + '</b>';
        sub.textContent = 'No interest or fees with humm.';
      } else if (paid.length) {
        var p = paid[0];
        line.innerHTML = paid.length > 1 ? 'or from <b>' + money2(monthly(p)) + ' a month</b>' : 'or <b>' + p.term + ' monthly payments of ' + money2(monthly(p)) + '</b>';
        sub.textContent = p.term + ' months · ' + p.interestRate + '% fixed rate · ' + p.apr + '% APR · total ' + money2(+p.totAmtPayable) + ' including ' + money2(+p.totFeeAmt) + ' fees';
      }
      var list = q('[data-ep-humm-plans]', row), more = q('[data-ep-humm-more]', row);
      if (list && more && (plans.length > 1 || (paid.length && free))) {
        list.innerHTML = plans.map(function (x) {
          if (!x.interest) return '<li><b>' + esc(x.offerDesc) + ':</b> 3 payments of ' + money2(+x.intFreeAmt || amt / 3) + ', no interest or fees</li>';
          return '<li><b>' + esc(x.offerDesc) + ':</b> ' + x.term + ' monthly payments of ' + money2(monthly(x)) + ' · total ' + money2(+x.totAmtPayable) + ' including ' + money2(+x.totFeeAmt) + ' fees · ' + x.interestRate + '% fixed rate · ' + x.apr + '% APR</li>';
        }).join('');
        more.hidden = false;
        more.addEventListener('click', function () {
          var open = more.getAttribute('aria-expanded') === 'true';
          more.setAttribute('aria-expanded', open ? 'false' : 'true');
          list.hidden = open;
          more.textContent = open ? 'All plans' : 'Hide plans';
        });
      }
      var warn = q('[data-ep-humm-warn]');
      if (warn) warn.hidden = false;
    }).catch(function () { /* keep the neutral server text */ });
  }

  /* ---------- humm payment calculator (Mix 3 Help me decide card), humm's widget design ----------
     Amounts: this product's price plus up to three larger basket examples (data-presets). Each amount's plans come
     from humm's widget API (cached per session); the arrows step through the plans (6 / 12 / 18 / 24 months...).
     All API values are written with textContent. "Buy with humm" adds the product (the main form's id + quantity)
     to the basket and goes to /checkout, where the customer chooses humm. */
  function initCalc() {
    var box = q('[data-ep-calc]');
    var link = q('[data-ep-calc-link]');
    if (!box) { if (link) link.hidden = true; return; }
    var mid = box.getAttribute('data-merchant'), price = parseFloat(box.getAttribute('data-price'));
    if (!(price >= 5) || !mid) return;
    var presets = (box.getAttribute('data-presets') || '').split(',').map(function (x) { return parseFloat(x); })
      .filter(function (x) { return x > price * 1.05; }).slice(0, 3);
    var amounts = [price].concat(presets);
    var body = q('[data-hm-body]', box), fb = q('[data-hm-fallback]', box), wrap = q('[data-hm-amts]', box);
    var prev = q('[data-hm-prev]', box), next = q('[data-hm-next]', box);
    var st = { amt: price, plans: null, i: 0, req: 0 };
    function n2(n) { return (Math.round((+n || 0) * 100) / 100).toLocaleString('en-IE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function label(n) { return '\u20AC' + n.toLocaleString('en-IE', { maximumFractionDigits: 2 }); }
    function set(sel, t) { var e = q(sel, box); if (e) e.textContent = t; }
    function render() {
      var p = st.plans[st.i];
      var monthly = p.interest ? (+p.intAmt || 0) + (+p.acctKeepingFee || 0) : (+p.intFreeAmt || 0);
      set('[data-hm-name]', p.offerDesc || (p.term + ' Months'));
      set('[data-hm-credit]', n2(st.amt));
      var sum = q('[data-hm-sum]', box);
      if (sum) {
        sum.textContent = (p.interest ? p.term + ' monthly payments of ' : p.term + ' interest-free payments of ');
        var b = d.createElement('b'); b.textContent = '\u20AC' + n2(monthly); sum.appendChild(b);
      }
      set('[data-hm-app]', n2(p.applicationFee));
      set('[data-hm-up]', n2(p.upfront));
      set('[data-hm-uptotal]', n2((+p.applicationFee || 0) + (+p.upfront || 0)));
      set('[data-hm-freq]', p.frequency || 'Monthly');
      set('[data-hm-term]', String(p.interest ? (p.intPeriod || p.term) : (p.intFreePeriod || p.term)));
      set('[data-hm-mf]', n2(p.acctKeepingFee));
      set('[data-hm-free]', (+p.intFreePeriod > 0 ? 'x ' + p.intFreePeriod + '\u00A0\u00A0' : '') + '\u20AC ' + n2(+p.intFreePeriod > 0 ? p.intFreeAmt : 0));
      set('[data-hm-rem]', (+p.intPeriod > 0 ? 'x ' + p.intPeriod + '\u00A0\u00A0' : '') + '\u20AC ' + n2(+p.intPeriod > 0 ? p.intAmt : 0));
      set('[data-hm-total]', n2(p.totAmtPayable));
      set('[data-hm-fees]', n2(p.totFeeAmt));
      set('[data-hm-rate]', (+p.interestRate || 0).toFixed(2));
      set('[data-hm-apr]', (+p.apr || 0).toFixed(2));
      if (prev) prev.disabled = st.i <= 0;
      if (next) next.disabled = st.i >= st.plans.length - 1;
    }
    function pick(a) {
      st.amt = a;
      qa('.hm-amt', wrap).forEach(function (bt) { bt.setAttribute('aria-pressed', +bt.getAttribute('data-a') === a ? 'true' : 'false'); });
      var mine = ++st.req;
      var url = 'https://urkwvzhzpc.execute-api.eu-west-1.amazonaws.com/prod/widget/' + encodeURIComponent(mid) + '/' + a.toFixed(2) + '/0';
      getJSON(url, 'eurhumm:' + mid + ':' + a.toFixed(2)).then(function (plans) {
        if (mine !== st.req) return;
        if (!plans || !plans.length) throw new Error('no plans');
        var keep = st.plans && st.plans[st.i] ? st.plans[st.i].term : null;
        st.plans = plans.slice().sort(function (x, y) { return (+x.term || 0) - (+y.term || 0); });
        st.i = 0;
        if (keep != null) st.plans.forEach(function (x, k) { if (x.term === keep) st.i = k; });
        render();
        if (body) body.hidden = false;
        if (fb) fb.hidden = true;
      }).catch(function () { if (!st.plans) { if (body) body.hidden = true; if (fb) fb.hidden = false; } });
    }
    if (wrap) amounts.forEach(function (a, k) {
      var bt = d.createElement('button');
      bt.type = 'button'; bt.className = 'hm-amt'; bt.setAttribute('data-a', String(a)); bt.setAttribute('aria-pressed', k === 0 ? 'true' : 'false');
      var b = d.createElement('b'); b.textContent = label(a);
      var sp = d.createElement('span'); sp.textContent = k === 0 ? 'This product' : 'Basket';
      bt.appendChild(b); bt.appendChild(sp);
      bt.addEventListener('click', function () { pick(a); });
      wrap.appendChild(bt);
    });
    if (prev) prev.addEventListener('click', function () { if (st.plans && st.i > 0) { st.i--; render(); } });
    if (next) next.addEventListener('click', function () { if (st.plans && st.i < st.plans.length - 1) { st.i++; render(); } });
    var buy = q('[data-hm-buy]', box), err = q('[data-hm-err]', box);
    if (buy) buy.addEventListener('click', function () {
      var form = q('form[id^="product-form-main-"]');
      if (!form) return;
      buy.disabled = true;
      if (err) err.hidden = true;
      var addUrl = ((window.routes && (window.routes.cartAddUrl || window.routes.cart_add_url)) || '/cart/add') + '.js';
      fetch(addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) {
          if (r.ok) {
            var go = function () { window.location.assign('/checkout'); };
            if (typeof window.__eurWarrantyAdd === 'function') return window.__eurWarrantyAdd().then(go, function () { window.location.assign('/cart'); });
            go(); return;
          }
          return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || 'Sorry, that could not be added to your basket.'); });
        })
        .catch(function (e) {
          buy.disabled = false;
          if (err) { err.textContent = (e && e.message) || 'Sorry, that could not be added to your basket.'; err.hidden = false; }
        });
    });
    pick(price);
  }

  /* ---------- Feefo ---------- */
  function initReviews() {
    var sec = q('[data-ep-reviews]'), rating = q('[data-ep-rating]');
    var sku = (sec && sec.getAttribute('data-sku')) || (main && main.getAttribute('data-sku'));
    var mid = (sec && sec.getAttribute('data-merchant')) || 'euronics-ireland';
    if (!sku) return;
    var base = 'https://api.feefo.com/api/10/reviews/summary/';
    function prod(s) { return getJSON(base + 'product?merchant_identifier=' + encodeURIComponent(mid) + '&product_sku=' + encodeURIComponent(s), 'eurfeefo:' + s); }
    function stars(r) {
      var full = Math.round(r * 2) / 2, out = '';
      for (var i = 1; i <= 5; i++) out += i <= full ? '★' : '☆';
      return '<span class="ep-stars" aria-hidden="true">' + out + '</span>';
    }
    prod(sku).then(function (j) {
      var n = (j && j.meta && j.meta.count) || 0, r = (j && j.rating && j.rating.rating) || 0;
      if (rating) {
        rating.innerHTML = n > 0
          ? stars(r) + '<span>' + r.toFixed(1) + '</span><a href="#reviews">' + n.toLocaleString('en-IE') + ' review' + (n === 1 ? '' : 's') + '</a><span class="ep-sr">Rated ' + r.toFixed(1) + ' out of 5</span>'
          : '<span>No reviews yet</span><span aria-hidden="true">·</span><a href="#reviews">About reviews</a>';
        rating.hidden = false;
      }
      if (!sec) return;
      var mainCard = q('[data-ep-rv-main]', sec);
      if (n > 0) {
        mainCard.innerHTML = '<span class="ep-rv__score">' + r.toFixed(1) + '</span><div style="flex:1;min-width:0"><h3>' + stars(r) + '</h3><p>Rated ' + r.toFixed(1) + ' out of 5 from ' + n.toLocaleString('en-IE') + ' verified review' + (n === 1 ? '' : 's') + ' on Feefo.</p></div>';
        lazyWidget(sec, sku);
      } else {
        q('[data-ep-rv-title]', sec).textContent = 'No reviews yet';
        q('[data-ep-rv-text]', sec).textContent = 'Feefo asks everyone who buys this model to review it after delivery, so reviews will appear here once owners have used it.';
      }
    }).catch(function () { if (rating) rating.hidden = true; });

    if (!sec) return;
    var side = q('[data-ep-rv-side]', sec);
    var sib = main ? (main.getAttribute('data-sib-skus') || '') : '';
    sib.split('|').filter(Boolean).slice(0, 3).forEach(function (t) {
      var p = t.split('~'), s = p[0], u = p[1], col = p[2] || 'another colour';
      if (!s) return;
      prod(s).then(function (j) {
        var n = (j && j.meta && j.meta.count) || 0, r = (j && j.rating && j.rating.rating) || 0;
        if (!n) return;
        var div = d.createElement('div');
        div.innerHTML = '<b>Same model in ' + esc(col) + '</b><span class="s">' + n + ' review' + (n === 1 ? '' : 's') + ', rated ' + r.toFixed(1) + ' out of 5.</span><a href="' + esc(u) + '#reviews" class="ep-lnk">Read the review' + (n === 1 ? '' : 's') + '</a>';
        side.insertBefore(div, side.firstChild);
      }).catch(function () {});
    });
    getJSON(base + 'service?merchant_identifier=' + encodeURIComponent(mid) + '&since_period=ALL', 'eurfeefo:service').then(function (j) {
      var n = (j && j.meta && j.meta.count) || 0, r = (j && j.rating && j.rating.rating) || 0, t = q('[data-ep-rv-service-text]', sec);
      if (n && t) t.textContent = 'Rated ' + r.toFixed(1) + ' out of 5 from ' + n.toLocaleString('en-IE') + ' service reviews.';
    }).catch(function () {});
  }
  function lazyWidget(sec, sku) {
    var host = q('[data-ep-rv-widget]', sec);
    if (!host) return;
    function mount() {
      if (host.childNodes.length) return;
      var el = d.createElement('feefo-product-reviews');
      el.setAttribute('sku', sku);
      host.appendChild(el);
      if (!q('script[src*="api.feefo.com/api/javascript/"]')) {
        var s = d.createElement('script');
        s.src = 'https://api.feefo.com/api/javascript/euronics-ireland';
        s.async = true;
        d.head.appendChild(s);
      }
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); mount(); } }, { rootMargin: '600px 0px' });
      io.observe(sec);
    } else mount();
  }

  /* ---------- comparison, specs, disclosures ---------- */
  function initToggles() {
    qa('[data-ep-cmp]').forEach(function (c) {
      var t = q('[data-ep-diff]', c);
      if (!t) return;
      if (!q('[data-ep-same]', c)) { t.closest('label').hidden = true; return; }
      t.addEventListener('change', function () { c.classList.toggle('is-diff', t.checked); });
    });
    var more = q('[data-ep-specs-more]'), specs = q('[data-ep-specs]');
    if (more && specs) more.addEventListener('click', function () {
      var open = specs.classList.toggle('is-open'), l = q('[data-ep-l]', more);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (l) l.textContent = l.getAttribute(open ? 'data-less' : 'data-more');
      if (!open) specs.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    function openTarget(id, focus) {
      var el = d.getElementById(id);
      if (!el) return false;
      if (el.tagName === 'DETAILS') el.open = true;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (focus) { var f = q(focus); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400); }
      return true;
    }
    d.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-ep-open]') : null;
      if (!a) return;
      var id = a.getAttribute('data-ep-open');
      if (openTarget(id, id === 'weee' ? '#gt-weee-h' : null)) e.preventDefault();
    });
    if (/^#(warranty|weee)$/.test(location.hash)) openTarget(location.hash.slice(1));
  }

  /* ---------- Otto ---------- */
  function initOtto() {
    var card = q('[data-ep-otto]');
    if (!card) return;
    function open(opts, el) {
      opts = opts || {};
      if (el) opts.opener = el;
      if (window.EuronicsAI && typeof window.EuronicsAI.open === 'function') { window.EuronicsAI.open(opts); return true; }
      var l = q('.eai-launcher__open'); if (l) { l.click(); return true; }
      return false;
    }
    var form = q('[data-ep-otto-form]', card), inp = form ? q('input', form) : null;
    if (form && inp) form.addEventListener('submit', function (e) {
      var v = (inp.value || '').trim(), ok = v ? open({ submit: v, source: 'pdp_otto' }, e.submitter || inp) : open({ source: 'pdp_otto' }, e.submitter || inp);
      if (!ok) return;
      e.preventDefault();
      inp.value = '';
    });
    qa('[data-ep-otto-q]', card).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!open({ submit: b.getAttribute('data-ep-otto-q'), source: 'pdp_otto_chip' }, b)) window.location.href = (form && form.getAttribute('action')) || '/pages/ai';
      });
    });
    function gate() {
      setTimeout(function () {
        if ((window.EuronicsAI && typeof window.EuronicsAI.open === 'function') || q('.eai-launcher__open')) return;
        card.hidden = true;
        var help = q('[data-ep-help]'); if (help) help.style.gridTemplateColumns = '1fr';
      }, 3000);
    }
    if (d.readyState === 'complete') gate(); else window.addEventListener('load', gate);
  }

  /* ---------- manufacturer content: reveal once 1WorldSync / Flix fill a slot ---------- */
  function initSynd() {
    var box = q('[data-ep-synd]');
    if (!box) return;
    var h = q('[data-ep-synd-h]', box), fold = q('[data-ep-synd-fold]', box), more = q('[data-ep-synd-more]', box),
        lbl = q('[data-ep-synd-lbl]', box);
    /* fold at 720px (eur-pdp.css), only when there is at least 240px more to show */
    var FOLD = 720, SLACK = 240, open = false, raf = 0;
    function check() {
      raf = 0;
      var got = qa('#ccs-feature-icons,#ccs-logos,#ccs-inline-content,#flix-inpage,[data-flix-embed-meta],.loadbeeTabContent', box)
        .reduce(function (t, el) { return t + el.offsetHeight; }, 0);
      if (h && got > 40) h.hidden = false;
      if (!fold || !more) return;
      var long = fold.scrollHeight > FOLD + SLACK;
      more.hidden = !long;
      box.classList.toggle('is-folded', long && !open);
    }
    function queue() { if (!raf) raf = requestAnimationFrame(check); }
    if (more) more.addEventListener('click', function () {
      open = !open;
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (lbl) lbl.textContent = open ? 'Show less' : 'Show more from the manufacturer';
      check();
      if (!open && box.getBoundingClientRect().top < 0) box.scrollIntoView({ block: 'start' });
    });
    /* the vendors' scripts write into the slots late (and keep resizing as images load) */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(queue);
      mo.observe(box, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 60000);
    }
    if ('ResizeObserver' in window && fold) {
      var ro = new ResizeObserver(queue);
      Array.prototype.forEach.call(fold.children, function (c) { ro.observe(c); });
    }
    window.addEventListener('load', queue);
    check();
  }

  /* ---------- long descriptions: folded with "Read the full description" (eur-pdp.css .ep-fold) ---------- */
  function initFolds() {
    qa('[data-ep-fold]').forEach(function (box) {
      var body = q('[data-ep-fold-body]', box), btn = q('[data-ep-fold-btn]', box), lbl = q('[data-ep-fold-lbl]', box);
      if (!body || !btn) return;
      var FOLD = parseInt(getComputedStyle(box).getPropertyValue('--ep-fold'), 10) || 520, SLACK = 200, open = false,
          more = lbl ? lbl.textContent : '', raf = 0;
      function check() {
        raf = 0;
        var long = body.scrollHeight > FOLD + SLACK;
        btn.hidden = !long;
        box.classList.toggle('is-folded', long && !open);
      }
      function queue() { if (!raf) raf = requestAnimationFrame(check); }
      /* content that arrives late (the Feefo widget, images) */
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(queue);
        var watch = function () { Array.prototype.forEach.call(body.children, function (c) { ro.observe(c); }); };
        watch();
        if ('MutationObserver' in window) new MutationObserver(function () { watch(); queue(); }).observe(body, { childList: true });
      }
      btn.addEventListener('click', function () {
        open = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (lbl) lbl.textContent = open ? 'Show less' : more;
        check();
        if (!open && box.getBoundingClientRect().top < 0) box.scrollIntoView({ block: 'start' });
      });
      window.addEventListener('load', queue);
      window.addEventListener('resize', queue);
      check();
    });
  }

  /* ---------- sponsored tracking (same dataLayer events as the default template) ---------- */
  function initSponsored() {
    function dl(x) { try { (window.dataLayer = window.dataLayer || []).push(x); } catch (e) {} }
    qa('[data-ep-sp]').forEach(function (sp) {
      var base = { campaign: sp.getAttribute('data-campaign'), brand: sp.getAttribute('data-brand'), placement: sp.getAttribute('data-placement') };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { dl(Object.assign({ event: 'sponsored_impression' }, base)); io.disconnect(); } }, { threshold: 0.4 });
        io.observe(sp);
      }
      sp.addEventListener('click', function (e) {
        var cta = e.target.closest('[data-ep-sp-cta]'), card = e.target.closest('[data-ep-sp-product]');
        if (cta) dl(Object.assign({ event: 'sponsored_cta_click' }, base));
        else if (card) dl(Object.assign({ event: 'sponsored_product_click', product_id: card.getAttribute('data-product-id') }, base));
      });
    });
  }

  /* ---------- Brightside extended warranty, direction C (snippets/eur-warranty.liquid) ----------
     Never pre-selected: the box starts unticked on every load and on back/forward. Ticking only records the choice; the
     plan is added once the theme's own Add to basket (assets/theme.js BuyButton) reports the product was added
     ("product:added" with productAdded true, from the main product form only, so "Goes well with" adds never bring a
     plan), with the same quantity and the hidden property _warranty_for = this product's handle. Then the header basket
     re-renders (cart:refresh). "Buy with humm" calls window.__eurWarrantyAdd before going to checkout. */
  function initWarranty() {
    var card = q('[data-ewc]');
    if (!card) return;
    var cb = q('[data-ewc-in]', card), dlg = q('[data-ewp]'), live = q('[data-ewc-live]', card), err = q('[data-ep-err]');
    var vid = +card.getAttribute('data-variant'), forH = card.getAttribute('data-for') || '', price = card.getAttribute('data-price') || '';
    var root = d.documentElement;
    function say(t) { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60); } }
    function sync() {
      var on = !!cb.checked;
      card.classList.toggle('is-on', on);
      card.classList.remove('is-err');
      if (!dlg) return;
      qa('[data-ewp-off],[data-ewp-add]', dlg).forEach(function (b) { b.hidden = on; });
      qa('[data-ewp-remove],[data-ewp-done]', dlg).forEach(function (b) { b.hidden = !on; });
    }
    cb.checked = false;
    sync();
    window.addEventListener('pageshow', function () { cb.checked = false; sync(); });
    cb.addEventListener('change', function () {
      sync();
      say(cb.checked ? 'Extended warranty selected, ' + price + '. It is added with the product.' : 'Extended warranty not selected.');
    });

    if (dlg && typeof dlg.showModal === 'function') {
      qa('[data-ewc-open]', card).forEach(function (b) {
        b.addEventListener('click', function () { sync(); dlg.showModal(); root.classList.add('ewp-lock'); });
      });
      dlg.addEventListener('close', function () { root.classList.remove('ewp-lock'); });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) { dlg.close(); return; }
        var t = e.target.closest ? e.target.closest('button') : null;
        if (!t || !dlg.contains(t)) return;
        if (t.hasAttribute('data-ewp-add')) { cb.checked = true; sync(); say('Extended warranty selected, ' + price + '. It is added with the product.'); dlg.close(); }
        else if (t.hasAttribute('data-ewp-remove')) { cb.checked = false; sync(); say('Extended warranty not selected.'); dlg.close(); }
        else if (t.hasAttribute('data-ewp-close')) dlg.close();
      });
    } else {
      /* no <dialog> support: the link goes to the warranty page */
      qa('[data-ewc-open]', card).forEach(function (b) { b.addEventListener('click', function () { window.location.href = '/pages/extended-warranty'; }); });
    }

    var addUrl = ((window.routes && (window.routes.cartAddUrl || window.routes.cart_add_url)) || '/cart/add') + '.js';
    function addCover(qty) {
      return fetch(addUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: vid, quantity: Math.max(1, qty || 1), properties: { _warranty_for: forH } }] })
      }).then(function (r) { if (!r.ok) throw new Error('cover ' + r.status); return r.json(); });
    }
    function qtyNow() { var i = q('form[id^="product-form-main-"] [name="quantity"]'); return i ? parseInt(i.value, 10) || 1 : 1; }
    window.__eurWarrantyAdd = function (qty) { return cb.checked ? addCover(qty || qtyNow()) : Promise.resolve(null); };

    d.addEventListener('product:added', function (e) {
      if (!cb.checked || !e.detail || !e.detail.productAdded) return;
      var f = e.target && e.target.closest ? e.target.closest('form') : null;
      /* getAttribute: the form's own input name="id" shadows form.id */
      if (!f || (f.getAttribute('id') || '').indexOf('product-form-main-') !== 0) return;
      addCover(e.detail.quantity || qtyNow()).then(function () {
        say('Extended warranty added to your basket.');
        root.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } }));
      }).catch(function () {
        card.classList.add('is-err');
        if (err) { err.textContent = 'Your product is in the basket, but the extended warranty could not be added. Please try again from the basket.'; err.hidden = false; }
      });
    });
  }

  /* ---------- photo fit (21 Oct 2026) ----------
     Packshots carry their own white margins, so a product used to fill as little as half the stage. Each gallery photo is
     measured once on a 160px copy: the product's box is every pixel with alpha > 24 and min(r,g,b) < 242 (the homepage's
     eu-fit rule), or alpha alone for a cut-out with see-through corners. Its slide gets --x0 --y0 --wf --hf and --ar plus
     .is-fit, and eur-pdp.css scales the product to 86% of the stage; a photo whose box is nearly all of it (a lifestyle
     shot) gets .is-full instead. Results are kept for the session; a CORS or canvas failure keeps the plain contain. */
  function initPhotoFit() {
    var KEY = 'eur-pdp-fit-1', cache = cacheGet(KEY) || {};
    function key(src) { return src.replace(/^https?:/, '').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); }
    function apply(s, m) {
      if (m.full) { s.classList.add('is-full'); return; }
      ['x0', 'y0', 'wf', 'hf', 'ar'].forEach(function (k, i) { s.style.setProperty('--' + k, m.v[i]); });
      s.classList.add('is-fit');
    }
    function fit(img) {
      var s = img.closest('.ep-slide'), src = img.currentSrc || img.src;
      if (!s || !src) return;
      var k = key(src);
      if (cache[k]) { apply(s, cache[k]); return; }
      var pr = new Image();
      pr.crossOrigin = 'anonymous';
      pr.onload = function () {
        try {
          var W = 160, H = Math.max(1, Math.round(160 * pr.naturalHeight / pr.naturalWidth));
          var c = d.createElement('canvas'); c.width = W; c.height = H;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(pr, 0, 0, W, H);
          var p = x.getImageData(0, 0, W, H).data, x0 = W, y0 = H, x1 = -1, y1 = -1;
          var cut = p[3] < 250 || p[(W - 1) * 4 + 3] < 250 || p[(H - 1) * W * 4 + 3] < 250 || p[(H * W - 1) * 4 + 3] < 250;
          for (var y = 0; y < H; y++) for (var i = 0; i < W; i++) {
            var o = (y * W + i) * 4;
            if (p[o + 3] > 24 && (cut || Math.min(p[o], p[o + 1], p[o + 2]) < 242)) {
              if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y;
            }
          }
          if (x1 < 0) return;
          var wf = (x1 + 1 - x0) / W, hf = (y1 + 1 - y0) / H;
          var m = wf > 0.96 && hf > 0.96 ? { full: 1 } :
            { v: [(x0 / W).toFixed(4), (y0 / H).toFixed(4), wf.toFixed(4), hf.toFixed(4), (pr.naturalWidth / pr.naturalHeight).toFixed(4)] };
          cache[k] = m; cacheSet(KEY, cache);
          apply(s, m);
        } catch (e) { /* tainted canvas: keep the plain contain */ }
      };
      pr.src = /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=160') : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    }
    qa('[data-ep-gal] .ep-slide img').forEach(function (img) {
      if (img.complete && img.naturalWidth) fit(img); else img.addEventListener('load', function () { fit(img); }, { once: true });
    });
  }

  function run(fn) { try { fn(); } catch (e) { if (window.console) console.warn('eur-pdp', e); } }
  function init() {
    [initGallery, initPhotoFit, initBuy, initJump, initEta, initHumm, initCalc, initReviews, initToggles, initOtto, initSynd, initFolds, initSponsored, initWarranty].forEach(run);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
